import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { ProjectUserDto } from 'projects/shared/src/lib/models/ProjectUser';
import { GroupRolesDialogComponent } from '../group-roles-dialog/group-roles-dialog.component';

@Component({
  selector: 'project-user-button-renderer',
  templateUrl: './project-user-button-renderer.component.html',
  styleUrls: ['./project-user-button-renderer.component.scss']
})
export class ProjectUserButtonRendererComponent implements ICellRendererAngularComp {

  params: any;
  icon_view!: string;
  projectDto!: ProjectDto;

  constructor(public dialog: MatDialog) { }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    return false;
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;

    this.icon_view = this.params.icon_view || null;
    this.refresh(params);
  }

  openViewGroupRoleDialog(){
    const rowData = [this.params.node.data];

    console.log("------> openViewGroupRoleDialog", rowData)
    let projectUserDto = new ProjectUserDto;
    projectUserDto.userName = (rowData[0].lastName != "")?rowData[0].firstName + " " + rowData[0].lastName: rowData[0].email;
    projectUserDto.id = rowData[0].id;
    projectUserDto.projectId = rowData[0].projectId;

    const dialogRef = this.dialog.open(GroupRolesDialogComponent, {width: '500px', data: projectUserDto});
  }
}
